<div class="mb-8 text-center">
  <h1 class="text-3xl md:text-4xl font-bold text-gray-800 mb-2">
    <span class="relative inline-block">
  {{ title}}
      <span class="absolute bottom-1 left-0 w-full h-3 bg-yellow-300 opacity-40 -z-10"></span>
    </span>
  </h1>
  <p class="text-gray-600 max-w-lg mx-auto">{{subtitle}}</p>
</div>
